import { GetterTree } from 'vuex';

export default <GetterTree<attendance.state.AttendanceState, RootState>>{};
